module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Paul Ainsworth for his constant support and encouragement")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jeff Chambers, Michael Chance, Paul Darlow, Tony Heald, Ken Keen,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dan Parker, Doreen Piper, Brian Rowe, Peter Shield, Steven Skelley,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chris Skidmore, Paul Stebbing, Steve Wyatt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Barnsley Archives, Derbyshire Archives, BMBC Bereavement Services")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("National Coalmining Museum, National Union of Mineworkers")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barnsley Chronicle")]), _vm._v(" digitised newspapers, the Tasker Trust")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0005-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Interpretation of the Oaks explosion by Darren Green (AKA L. Gold).")])]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Websites")])]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Ancestry, FindMyPast*, the Genealogist – subscriptions (* newspapers)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("FreeBMD, GRO.gov, gov.uk/search-will-probate, cemeteries.org.uk, find a grave")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("TaskerTrust.co.uk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Durham Mining Museum, healeyhero.co.uk,")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("DVLP website for Oaks 1866 victims")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dearne Memorials Group database, Ardsley Residents Association website")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Peter Higginbotham’s workhouses.org.uk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Measuringworth.com")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Visionofbritain.org.uk")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Wikipedia and many general searches for background information")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Front Cover - “Head to Face” was embroidered by Maureen Livesey and purchased by the Author")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Back Cover - both drawings of the Oaks Colliery explosion 1847 were produced for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Illustrated London News")]), _vm._v(" (Barnsley Archives)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1a"
  }, [_vm._v("Where the copyright of a photograph is not indicated it is the property of the Author and may not be used without permission")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0006-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Ledger record of the Annual Meeting 1849. (© Barnsley Archives)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e62ef9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Chapter02.vue
// module id = 81
// module chunks = 0